import { Grid, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { ArrowDownward, Block, Info, Save } from "@material-ui/icons";
import Config, {
  PERMISSION_ROLE_HIS_PAYMENT,
  PROMOTION_CODES,
  REQUIRED_CTKM,
  REQUIRED_CTKM_DISCOUNT,
} from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsAutocomplete from "app/common/form/GlobitsAutocomplete";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import GlobitsVNDCurrencyInputOnlyChange from "app/common/form/GlobitsVNDCurrencyInputOnlyChange";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import {
  CARD_PATIENT_STATUS,
  LEAD_SOURCE_LEVEL,
  PathModule,
  POPUP_TYPE_CHANGE_SERVICE,
  TYPE_CARD,
} from "app/common/LocalConst";
import {
  formatMoney,
  getDepartmentsUser,
  getPriceTypeService,
  getPromotionCodes,
  handleDefaultServiceWarranty,
  isAdmin,
  isRoleHisPayment,
  validateEqualsSourceDiffirentTelesale,
  validateMaxTotalAmountTelesale,
  validateMaxTotalDiffTelesale,
  validateSelectDiffirentTelesale,
  validateSelectTelesale,
} from "app/common/LocalFunction";
import DeductionList from "app/PatientManagement/DeductionList/DeductionList";
import { pagingClientCard } from "app/services/ClientCardService";
import { getListCode } from "app/services/CustomerSourceService";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingDrug } from "app/services/DrugService";
import { pagingHealthCareService } from "app/services/HealthCareService";
import { pagingProgram } from "app/services/PromotionCRMService";
import { useStore } from "app/stores";
import { getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { filterBaseOptions } from "utils";
import * as Yup from "yup";
import { CardUser } from "../../RegisterCardTab/Popup/RegisterCardPopup";
import RowTotalChangeTreatmentPlan from "../../RegisterProductTab/Component/RowTotalChangeTreatmentPlan";
import PaServiceRegisterTable, {
  renderOptionsDrug,
  renderOptionsService,
} from "../../RegisterServiceTreatmentPlanTab/Component/PaServiceRegisterTable";
import RegisterChangeTreatmentStaffsRevenue from "../../RegisterServiceTreatmentPlanTab/Component/RegisterChangeTreatmentStaffsRevenue";
import {
  ButtonDeleteProgram,
  PromotionProgram,
} from "../../RegisterServiceTreatmentPlanTab/Popup/ChangeTreatmentPlanPopup";

const ChangeServiceToClientCardPopup = ({
  open,
  handleClose,
  onSubmit,
  initChangeService,
  listVatPercent,
  customerSourceWalkIn,
  handleAfterSubmit,
  treatmentFree,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const { handleGetListVatPercent, initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;

  useEffect(() => {
    handleGetListVatPercent();
  }, []);
  const department = useDefaultDepartment();
  const validationSchema = Yup.object().shape({
    department: Yup.object().nullable().required("Chưa cơ sở!"),
    staffRevenues: Yup.array()
      .min(1, "Cần thêm ít nhất 1 phân bổ!")
      .of(
        Yup.object()
          .shape({
            position: Yup.object()
              .nullable()
              .required("Bắt buộc nhập chức danh"),
            staff: Yup.object().nullable(),
            source: Yup.object().nullable(),
            actualAmount: Yup.mixed()
              .nullable()
              .test("greater-than-zero", "Giá trị phải lớn hơn 0!", (value) => {
                if (value === null || value === "") return true;
                return value >= 0;
              }),
            percentRevenue: Yup.mixed()
              .nullable()
              .test(
                "max-100",
                "Phân bổ doanh thu phải nhỏ hơn hoặc bằng 100!",
                (value) => {
                  if (value === null || value === "") return true;
                  return value <= 100;
                }
              ),
          })
          .test(
            "at-least-one-selected",
            "Phải chọn Nhân viên!",
            function (value) {
              if (!value) return false;
              const { staff } = value;
              return !!staff;
            }
          )
      )
      .test(
        "at-least-one-diffirent-sale",
        "Cần chọn phân bổ cho người tư vấn !",
        validateSelectDiffirentTelesale
      )
      .test(
        "at-least-one-sale",
        "Cần chọn phân bổ cho telesale!",
        validateSelectTelesale
      )
      .test(
        "max-total-amount-telesale",
        "Tổng phân bổ telesale phải bằng 100%",
        validateMaxTotalAmountTelesale
      )
      .test(
        "max-total-amount-consultant",
        "Tổng phân bổ tư vấn viên và kĩ thuật viên phải bằng 100%",
        validateMaxTotalDiffTelesale
      )
      .test(
        "equals-source-revenue-sale-diffirent",
        "Tổng phân bổ telesale phải bằng các chức danh khác trong cùng nguồn!",
        validateEqualsSourceDiffirentTelesale
      )
      .nullable(),
    oldCredit: Yup.number()
      .test(
        "smaller than remainingAmount",
        "Tiền khấu trừ phải nhỏ hơn tổng tiền còn lại !",
        function (value) {
          const { oldPatientServiceRegister } = this.parent;
          if (value > oldPatientServiceRegister?.remainingAmount) {
            return false;
          }
          return true;
        }
      )
      .nullable(),
    paServiceRegister: Yup.array()
      .of(
        Yup.object().shape({
          oldCredit: Yup.number()
            .test(
              "validate-oldCredit",
              "Tiền khấu trừ dịch vụ phải nhỏ hơn thành tiền dịch vụ",
              function (value) {
                const { amount } = this.parent;
                if (amount < value) {
                  return false;
                }
                return true;
              }
            )
            .test(
              "validate-oldCredit-positive ",
              "Tiền khấu trừ > 0",
              function (value) {
                if (value < 0) {
                  return false;
                }
                return true;
              }
            )
            .nullable(),

          amount: Yup.number()
            .typeError("Thành tiền phải là số")
            .test(
              "validate-amount",
              "Không được bán dưới mức giá tối thiểu",
              function (amount) {
                const { quantity, service } = this.parent;
                if (!quantity || !service?.minSellingPrice || !amount) {
                  return true;
                } else {
                  let minSellingPriceVal = amount / quantity;
                  if (minSellingPriceVal < service?.minSellingPrice) {
                    return false;
                  }
                  return true;
                }
              }
            )
            .nullable(),

          percentDiscount: Yup.number()
            .max(100, "Giảm giá phải nhỏ hơn 100!")
            .test(
              "validate-percentDiscount",
              "Không được quá % giảm giá của chương trình khuyến mãi này",
              function (value) {
                const { promotionProgram } = this.parent;
                if (!PROMOTION_CODES?.includes(promotionProgram?.code)) return;

                if (
                  promotionProgram &&
                  promotionProgram?.allProductMaxDiscountPercent != null
                ) {
                  if (value > promotionProgram?.allProductMaxDiscountPercent)
                    return false;
                }
                if (
                  promotionProgram &&
                  promotionProgram?.products?.length > 0
                ) {
                  if (value > promotionProgram?.products[0]?.maxDiscountPercent)
                    return false;
                }
                return true;
              }
            )
            .nullable(),
          ...(REQUIRED_CTKM
            ? {
                promotionProgram: Yup.object()
                  .nullable()
                  .required("Chưa chọn CTKM!"),
              }
            : {}),
        })
      )
      .nullable(),

    drugs: Yup.array()
      .of(
        Yup.object().shape({
          oldCredit: Yup.number()
            .test(
              "validate-oldCredit",
              "Tiền khấu trừ sản phẩm phải nhỏ hơn thành tiền sản phẩm",
              function (value) {
                const { amount } = this.parent;
                if (amount < value) {
                  return false;
                }
                return true;
              }
            )
            .test(
              "validate-oldCredit-positive ",
              "Tiền khấu trừ > 0",
              function (value) {
                if (value < 0) {
                  return false;
                }
                return true;
              }
            )
            .nullable(),
          amount: Yup.number()
            .typeError("Thành tiền phải là số")

            .test(
              "validate-amount",
              "Không được bán dưới mức giá tối thiểu",
              function (amount) {
                const { soldQuantity, service } = this.parent;
                if (!soldQuantity || !service?.minSellingPrice || !amount) {
                  return true;
                } else {
                  let minSellingPriceVal = amount / soldQuantity;
                  if (minSellingPriceVal < service?.minSellingPrice) {
                    return false;
                  }
                  return true;
                }
              }
            )
            .nullable(),
          percentDiscount: Yup.number()
            .max(100, "Giảm giá phải nhỏ hơn 100!")
            .test(
              "validate-percentDiscount",
              "Không được quá % giảm giá của chương trình khuyến mãi này",
              function (value) {
                const { promotionProgram } = this.parent;
                if (!PROMOTION_CODES?.includes(promotionProgram?.code)) return;

                if (
                  promotionProgram &&
                  promotionProgram?.allProductMaxDiscountPercent != null
                ) {
                  if (value > promotionProgram?.allProductMaxDiscountPercent)
                    return false;
                }
                if (
                  promotionProgram &&
                  promotionProgram?.products?.length > 0
                ) {
                  if (value > promotionProgram?.products[0]?.maxDiscountPercent)
                    return false;
                }
                return true;
              }
            )
            .nullable(),
          ...(REQUIRED_CTKM
            ? {
                promotionProgram: Yup.object()
                  .nullable()
                  .required("Chưa chọn CTKM!"),
              }
            : {}),
        })
      )
      .nullable(),
    percentDiscount: Yup.number()
      .min(0, "Giảm giá phải lớn hơn 0!")
      .max(100, "Giảm giá không vượt quá  100!")
      .test(
        "validate-percentDiscount",
        "Không được quá % giảm giá của chương trình khuyến mãi này",
        function (value) {
          const { promotionProgram } = this.parent;
          if (!PROMOTION_CODES?.includes(promotionProgram?.code)) return;

          if (
            promotionProgram &&
            promotionProgram?.allProductMaxDiscountPercent != null
          ) {
            if (value > promotionProgram?.allProductMaxDiscountPercent)
              return false;
          }
          if (promotionProgram && promotionProgram?.products?.length > 0) {
            if (value > promotionProgram?.products[0]?.maxDiscountPercent)
              return false;
          }
          return true;
        }
      )
      .nullable(),
  });
  const source = initialPatient?.patientInfo?.currentPatientSource;

  return (
    <PopupForm
      open={open}
      size="xl"
      handleClose={handleClose}
      title={`Đổi dịch vụ`}
      formik={{
        initialValues: {
          department,
          patientId: initialPatient?.patientInfo?.id,
          patient: initialPatient?.patientInfo,
          ...initChangeService,
          sourceRevenue: source,
          defaultCard: false,
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
          const hasService = values?.paServiceRegister?.length > 0;
          const hasDrug = values?.drugs?.length > 0;

          if (!values?.defaultCard && !hasService && !hasDrug) {
            toast.error("Vui lòng chọn ít nhất một dịch vụ hoặc sản phẩm!");
            setSubmitting(false);
            return;
          }
          let data = await onSubmit(values);
          if (handleAfterSubmit && data?.responseStatus !== false) {
            handleAfterSubmit();
          }
        },
        enableReinitialize: true,
      }}
      action={({ isSubmitting, setFieldValue, submitForm }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton
              type="submit"
              className="btn-primary"
              disabled={isSubmitting}
            >
              {!isMobile && <Save className="mr-2 " />}
              {`Đổi dịch vụ`}
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              listVatPercent={listVatPercent}
              patient={initialPatient?.patientInfo}
              initChangeService={initChangeService}
              customerSourceWalkIn={customerSourceWalkIn}
              treatmentFree={treatmentFree}
            />
            <DialogError
              patient={initialPatient?.patientInfo}
              setFieldValue={setFieldValue}
              values={values}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(
  ({ listVatPercent, patient, treatmentFree, initChangeService }) => {
    const { setFieldValue, values } = useFormikContext();
    let isPaymentPermission = isRoleHisPayment();
    const { defaultFreePromotion } = useStore().feeStore.serviceFeeTabStore;
    let listFreeCode = getPromotionCodes();

    let totalAmountRevenues = 0;

    totalAmountRevenues =
      +values?.totalAmount -
      (+values?.discount || 0) +
      (+values?.taxTotal || 0);

    const handleAddProductAndService = () => {
      let feeItemSerive;
      let feeItemDrug;
      let totalAmountDrugs = 0;
      let totalAmountServices = 0;
      let newpaServiceRegister = [...(values?.paServiceRegister || [])];
      let newDrugs = [...(values?.drugs || [])];
      let taxTotalDrugVatInclude = 0;
      let taxTotalDrug = 0;
      let taxTotalServiceVatInclude = 0;
      let taxTotalService = 0;

      if (values?.servicePush) {
        feeItemSerive =
          values?.servicePush?.serviceFeeList?.length > 0
            ? getPriceTypeService(
                getIn(values, "patientTypeService"),
                values?.servicePush?.serviceFeeList || []
              )
            : null;

        let taxPercent = feeItemSerive?.serviceVAT?.vatPercent?.toString() || 0;

        if (feeItemSerive?.vatIncluded) {
          taxTotalServiceVatInclude =
            ((feeItemSerive?.price * 1) / (+taxPercent + 100)) * +taxPercent;
        } else {
          taxTotalService =
            feeItemSerive?.price * 1 * ((+taxPercent || 0) / 100);
        }

        let warrantyInfo = handleDefaultServiceWarranty(
          values?.servicePush,
          feeItemSerive
        );
        const newPrice = feeItemSerive?.price ? +feeItemSerive?.price : 0;
        let newService = {
          service: values?.servicePush,
          name: values?.servicePush?.name,
          quantity: 1,
          currentEdit: true,
          price: newPrice,
          amount: newPrice,
          isEditable: true,
          fees: values?.servicePush?.serviceFeeList?.map((el) => ({
            ...el?.patientTypeService,
            price: el?.price,
            vatIncluded: el?.vatIncluded,
            serviceVAT: el?.serviceVAT,
            patientTypeService: el?.patientTypeService,
          })),
          patientTypeService: feeItemSerive,
          priceWithTax: feeItemSerive?.vatIncluded,
          taxTotal: taxTotalService + taxTotalServiceVatInclude,
          taxPercent,
          // promotionProgram: defaultFreePromotion,
          ...warrantyInfo,
        };
        newpaServiceRegister = [...newpaServiceRegister, { ...newService }];
      }
      totalAmountServices = newpaServiceRegister?.reduce((acc, curr) => {
        return (
          acc + (curr?.quantity || 1) * curr?.price - (curr?.discount || 0)
        );
      }, 0);

      if (values?.drugPush) {
        feeItemDrug =
          values?.drugPush?.drugUnitPrices?.length > 0
            ? getPriceTypeService(
                getIn(values, "patientTypeService"),
                values?.drugPush?.drugUnitPrices || []
              )
            : null;

        let taxPercent = feeItemDrug?.serviceVAT?.vatPercent?.toString() || 0;

        if (feeItemDrug?.isTaxIncluded) {
          taxTotalDrugVatInclude =
            ((feeItemDrug?.price * 1) / (+taxPercent + 100)) * +taxPercent;
        } else {
          taxTotalDrug = feeItemDrug?.price * 1 * ((+taxPercent || 0) / 100);
        }
        const newPrice = feeItemDrug?.price ? +feeItemDrug?.price : 0;

        let newDrug = {
          drug: values?.drugPush,
          name: values?.drugPush?.name,
          soldQuantity: 1,
          currentEdit: true,
          price: newPrice,
          amount: newPrice,
          isEditable: true,
          fees: values?.drugPush?.drugUnitPrices?.map((el) => ({
            ...el?.patientTypeService,
            price: el?.price,
            vatIncluded: el?.isTaxIncluded,
            serviceVAT: el?.serviceVAT,
            patientTypeService: el?.patientTypeService,
          })),
          patientTypeService: feeItemDrug,
          priceWithTax: feeItemDrug?.isTaxIncluded,
          taxTotal: +taxTotalDrug + +taxTotalDrugVatInclude,
          taxPercent,
          // promotionProgram: defaultFreePromotion,
        };
        newDrugs = [...newDrugs, { ...newDrug }];
      }

      totalAmountDrugs = newDrugs?.reduce((acc, curr) => {
        return (
          acc + (curr?.quantity || 1) * curr?.price - (curr?.discount || 0)
        );
      }, 0);

      //  set lại tiền thuế
      setFieldValue(
        "taxTotal",
        (+values?.taxTotal || 0) + taxTotalDrug + taxTotalService
      );

      //TH ko lấy giá tổng
      if (!values?.isTotalPriceUsed) {
        setFieldValue(
          "totalAmount",
          (+values?.totalAmount || 0) +
            (+feeItemSerive?.price || 0) +
            (+feeItemDrug?.price || 0)
        );
      } else {
        const totalAmountItem = +totalAmountServices + +totalAmountDrugs;
        if (values?.totalAmount < totalAmountItem) {
          const percentAllocateItem =
            (totalAmountItem - values?.totalAmount) / totalAmountItem;
          const formatDataService = newpaServiceRegister?.map((el, ind) => ({
            ...el,
            percentDiscount: percentAllocateItem,
            discount:
              percentAllocateItem *
              el?.price *
              (el?.unLimited ? 1 : el?.quantity),
          }));

          const formatDataDrugs = newDrugs?.map((el, ind) => ({
            ...el,
            percentDiscount: percentAllocateItem,
            discount:
              percentAllocateItem *
              el?.price *
              (el?.unLimited ? 1 : el?.soldQuantity),
          }));

          setFieldValue(`paServiceRegister`, formatDataService);
          setFieldValue(`drugs`, formatDataDrugs);
        }
      }

      // xử lí nếu khấu trừ > 0 thì phân bổ tiền khấu trừ xuống
      if (values?.oldCredit > 0) {
        const totalAmountItem = +totalAmountServices + +totalAmountDrugs;
        const percentOldCreditItem = values?.oldCredit / totalAmountItem; // tính % có thể phân bổ xuống

        // gán tạm
        newpaServiceRegister = newpaServiceRegister?.map((el, ind) => {
          const oldCredit = (percentOldCreditItem * el?.amount).toFixed();
          return {
            ...el,
            oldCredit: el?.amount > 0 ? oldCredit : 0,
          };
        });

        newDrugs = newDrugs?.map((el, ind) => {
          const oldCredit = (percentOldCreditItem * el?.amount).toFixed();

          return {
            ...el,
            oldCredit: el?.amount > 0 ? oldCredit : 0,
          };
        });

        //  kiểm tra tổng
        let allocatedTotal =
          newpaServiceRegister.reduce((sum, el) => sum + +el.oldCredit, 0) +
          newDrugs.reduce((sum, el) => sum + +el.oldCredit, 0);

        let diff = +(values?.oldCredit - allocatedTotal);

        //  cộng/trừ chênh lệch vào item cuối cùng
        if (diff !== 0) {
          if (newDrugs.length > 0) {
            newDrugs[newDrugs.length - 1].oldCredit =
              +newDrugs[newDrugs.length - 1].oldCredit + diff;
          } else if (newpaServiceRegister.length > 0) {
            newpaServiceRegister[newpaServiceRegister.length - 1].oldCredit =
              +newpaServiceRegister[newpaServiceRegister.length - 1]
                ?.oldCredit + diff;
          }
        }
      }
      //console.log("newpaServiceRegister", newpaServiceRegister);
      setFieldValue(`paServiceRegister`, newpaServiceRegister);
      setFieldValue(`drugs`, newDrugs);

      setFieldValue("servicePush", null);
      setFieldValue("drugPush", null);
    };

    const handleCalPercentRevenue = (dataTotalAmount) => {
      if (!(dataTotalAmount > 1)) {
        return {
          percentDifferenceOld: 100,
          percentRevenueNew: 100,
        };
      }
      let percentDifferenceOld;
      let percentRevenueNew; //cth tính doanh thu dựa trên đã trả tiền hay chưa
      //nếu chưa trả thì lấy tiền phải trả / tổng để tính % ông cũ,
      // ông mới thì lấy tổng cần thu -  phải trả / tổng cần thu
      if (values?.oldPatientServiceRegister?.totalBillPatientPaid > 0) {
        const remaining =
          values?.oldPatientServiceRegister?.amountActuallyPaid -
            values?.oldPatientServiceRegister?.totalBillPatientPaid || 0;
        percentDifferenceOld = remaining / dataTotalAmount;

        percentRevenueNew =
          ((dataTotalAmount - remaining) / dataTotalAmount) * 100;
      } else {
        percentDifferenceOld =
          values?.oldPatientServiceRegister?.amountActuallyPaid /
          dataTotalAmount;
        percentRevenueNew =
          ((dataTotalAmount -
            values?.oldPatientServiceRegister?.amountActuallyPaid) /
            dataTotalAmount) *
          100;
      }
      return {
        percentDifferenceOld,
        percentRevenueNew,
      };
    };

    const handleAllocationRevenue = (totalAmount, staffRevenues, oldCredit) => {
      const dataTotalAmount = totalAmount - oldCredit; // sử dụng tiền sau khi trừ đi tiền khấu trừ
      const { percentDifferenceOld, percentRevenueNew } =
        handleCalPercentRevenue(dataTotalAmount);

      staffRevenues = staffRevenues?.map((el) => {
        if (el?.originTreatmentId) {
          //xử lí tk cũ
          let percentRevenue = percentDifferenceOld * el?.oldPercentRevenue;

          const actualAmount = Number((percentRevenue * dataTotalAmount) / 100);
          return {
            ...el,
            percentRevenue,
            actualAmount,
          };
        } else {
          let percentRevenue = percentRevenueNew > 0 ? percentRevenueNew : 0;
          const actualAmount = Number((percentRevenue * dataTotalAmount) / 100);
          return {
            ...el,
            percentRevenue,
            actualAmount,
          };
        }
      });
      return staffRevenues;
    };

    const handleAddStaff = (staff) => {
      let dataTotalAmount = 0;
      if (values?.priceWithTax) {
        dataTotalAmount =
          values?.totalAmount - (+values?.discount || 0) - values?.oldCredit;
      } else {
        dataTotalAmount =
          values?.totalAmount -
          (+values?.discount || 0) +
          (+values?.taxTotal || 0) -
          values?.oldCredit;
      }

      let staffRevenues = [...(values?.staffRevenues || []), staff];

      const { percentDifferenceOld, percentRevenueNew } =
        handleCalPercentRevenue(dataTotalAmount);

      staffRevenues = staffRevenues?.map((el) => {
        if (el?.originTreatmentId) {
          //xử lí tk cũ
          let percentRevenue = percentDifferenceOld * el?.oldPercentRevenue;
          return {
            ...el,
            percentRevenue,
            actualAmount: ((percentRevenue * dataTotalAmount) / 100).toFixed(4),
          };
        } else {
          let percentRevenue = percentRevenueNew > 0 ? percentRevenueNew : 0;

          return {
            ...el,
            percentRevenue,
            actualAmount: ((percentRevenue * dataTotalAmount) / 100).toFixed(4),
          };
        }
      });
      setFieldValue("staffRevenues", staffRevenues);
    };

    const handleOnChangeService = (value) => {
      setFieldValue("clientCard", value);
      setFieldValue("isTotalPriceUsed", value?.isTotalPriceUsed);

      let feeItem;
      let price;
      let totalAmount;
      let totalAmountServices = 0;
      let totalAmountDrugs = 0;
      let totalDiscount = 0;

      feeItem =
        value?.clientCardFees?.length > 0
          ? getPriceTypeService(
              getIn(values, "patientTypeService"),
              value?.clientCardFees || []
            )
          : null;

      if (value?.services && value?.services?.length > 0) {
        totalAmountServices = value?.services?.reduce((acc, curr) => {
          return acc + (curr?.quantity || 1) * curr?.netPrice;
        }, 0);
      }
      if (value?.products && value?.products?.length > 0) {
        totalAmountDrugs = value?.products?.reduce((acc, curr) => {
          return acc + (curr?.quantity || 1) * curr?.netPrice;
        }, 0);
      }

      if (value?.isTotalPriceUsed) {
        //nếu lấy giá tổng thì lấy theo loại giá
        price = feeItem?.price || value?.totalNetPrice;
        totalAmount = price * values?.quantity;
      } else {
        totalAmount = price = totalAmountServices + +totalAmountDrugs;
      }

      if (
        (value?.services && value?.services?.length > 0) ||
        (value?.products && value?.products?.length > 0)
      ) {
        let formatDataService;
        let formatDataDrug;
        // lấy theo giá tổng // logic giá tổng = tổng giá thành phần ,nếu ko = thì phân bổ tiền sang giảm giá

        if (!value?.isTotalPriceUsed) {
          const percentOldCreditItem = values?.oldCredit / totalAmount;

          formatDataService = value?.services?.map((el) => {
            const oldCredit = (percentOldCreditItem * el?.netPrice).toFixed();

            const feeSv =
              el?.fees?.length > 0
                ? getPriceTypeService(el?.patientTypeService, el?.fees || [])
                : null;
            let taxTotal = 0;
            let taxPercent = feeSv?.serviceVAT?.vatPercent?.toString() || 0;

            if (feeSv?.vatIncluded) {
              taxTotal =
                ((el?.netPrice * el?.quantity - (el?.discount || 0)) /
                  (+taxPercent + 100)) *
                +taxPercent;
            } else {
              taxTotal =
                (el?.netPrice * el?.quantity - (el?.discount || 0)) *
                ((+taxPercent || 0) / 100);
            }
            const quantity = el?.unLimited ? 1 : el?.quantity;
            totalDiscount += feeSv?.discount * quantity;

            return {
              service: el?.service,
              name: el?.service?.name,

              quantity,
              note: "",
              unLimited: el?.unLimited,
              price: feeSv?.price || 0,
              amount: quantity * (feeSv?.price - (feeSv?.discount || 0)),
              discount: feeSv?.discount * quantity,
              percentDiscount: feeSv?.percentDiscount,
              isEditable: el?.isEditable,
              taxPercent,
              taxTotal,
              priceWithTax: feeSv?.vatIncluded,
              fees: el?.fees?.map((el) => ({
                ...el?.patientTypeService,
                price: el?.price,
                vatIncluded: el?.vatIncluded,
                serviceVAT: el?.serviceVAT,
                patientTypeService: el?.patientTypeService,
              })),
              patientTypeService: feeSv,
              oldCredit: oldCredit,
            };
          });

          formatDataDrug = value?.products?.map((el) => {
            const oldCredit = (percentOldCreditItem * el?.netPrice).toFixed();
            const feeSv =
              el?.fees?.length > 0
                ? getPriceTypeService(el?.patientTypeService, el?.fees || [])
                : null;
            let taxTotal = 0;
            let taxPercent = feeSv?.serviceVAT?.vatPercent?.toString() || 0;

            if (feeSv?.vatIncluded) {
              taxTotal =
                ((el?.netPrice * el?.quantity - (el?.discount || 0)) /
                  (+taxPercent + 100)) *
                +taxPercent;
            } else {
              taxTotal =
                (el?.netPrice * el?.quantity - (el?.discount || 0)) *
                ((+taxPercent || 0) / 100);
            }
            const soldQuantity = el?.unLimited ? 1 : el?.quantity;
            totalDiscount += feeSv?.discount * soldQuantity;

            return {
              drug: el?.drug,
              name: el?.drug?.name,
              soldQuantity,
              price: feeSv?.price || 0,
              amount: soldQuantity * (feeSv?.price - (feeSv?.discount || 0)),
              discount: feeSv?.discount * soldQuantity,
              percentDiscount: feeSv?.percentDiscount,
              note: "",
              unLimited: el?.unLimited,
              isEditable: el?.isEditable,
              priceWithTax: feeSv?.vatIncluded,
              taxPercent,
              taxTotal,
              fees: el?.fees?.map((el) => ({
                ...el?.patientTypeService,
                price: el?.price,
                vatIncluded: el?.vatIncluded,
                serviceVAT: el?.serviceVAT,
                patientTypeService: el?.patientTypeService,
              })),
              patientTypeService: feeSv,
              oldCredit: oldCredit,
            };
          });
          //  kiểm tra tổng
          let allocatedTotalSv =
            formatDataService?.length > 0
              ? formatDataService.reduce((sum, el) => sum + +el.oldCredit, 0)
              : 0;
          let allocatedTotalDrug =
            formatDataDrug?.length > 0
              ? formatDataDrug.reduce((sum, el) => sum + +el.oldCredit, 0)
              : 0;
          let allocatedTotal = allocatedTotalSv + allocatedTotalDrug;

          let diff = +(values?.oldCredit - allocatedTotal);

          //cộng/trừ chênh lệch vào item cuối cùng
          if (diff !== 0) {
            if (formatDataDrug.length > 0) {
              formatDataDrug[formatDataDrug.length - 1].oldCredit =
                +formatDataDrug[formatDataDrug.length - 1].oldCredit + diff;
            } else if (formatDataService.length > 0) {
              formatDataService[formatDataService.length - 1].oldCredit =
                +formatDataService[formatDataService.length - 1]?.oldCredit +
                diff;
            }
          }
        }

        setFieldValue("paServiceRegister", formatDataService);
        setFieldValue("drugs", formatDataDrug);
        // setFieldValue("discount", oldCredit);
      } else {
        setFieldValue("paServiceRegister", []);
        setFieldValue("drugs", []);
      }
      setFieldValue("price", price);
      setFieldValue("totalAmount", totalAmount);
      setFieldValue("discount", totalDiscount);

      setFieldValue("patientTypeService", {
        ...feeItem?.patientTypeService,
        price: feeItem?.price,
      });
    };

    const handleOnChangeCard = (value) => {
      setFieldValue("clientCard", value);
      setFieldValue("isTotalPriceUsed", value?.isTotalPriceUsed);
      setFieldValue("allowUpdateUsedValue", value?.allowUpdateUsedValue);
      setFieldValue("promotionProgram", null);

      let feeItem;
      let price;
      let totalAmount;

      feeItem =
        value?.clientCardFees?.length > 0
          ? getPriceTypeService(
              getIn(values, "patientTypeService"),
              value?.clientCardFees || []
            )
          : null;

      //nếu lấy giá tổng thì lấy theo loại giá
      price = feeItem?.price || value?.totalNetPrice;
      totalAmount = price * values?.quantity;

      //gia su dung
      if (value?.totalPrice) {
        setFieldValue("totalValue", value?.totalPrice);
      } else if (value?.usedValueRate) {
        const totalValue =
          price * (values?.quantity || 1) * value?.usedValueRate;
        setFieldValue("totalValue", totalValue);
      } else {
        setFieldValue("totalValue", price * values?.quantity);
      }
      setFieldValue("paServiceRegister", []);
      setFieldValue("drugs", []);

      setFieldValue("price", price);
      setFieldValue("totalAmount", totalAmount);
      setFieldValue("patientTypeService", {
        ...feeItem?.patientTypeService,
        price: feeItem?.price,
      });

      setFieldValue("cardUsers", [
        {
          patient: patient,
          userStatus: CARD_PATIENT_STATUS[0].value,
          isMainUser: true,
        },
      ]);
    };
    const handleOnChangePrice = (e) => {
      let price = +e?.target?.value;
      let totalAmount = values?.quantity * price;
      setFieldValue("price", price);
      setFieldValue("totalAmount", totalAmount);
    };

    const handleOnChangeTotalAmount = (e) => {
      let totalAmount = e.target.value;
      setFieldValue("totalAmount", totalAmount);
      setFieldValue("price", totalAmount / (values?.quantity || 1));
    };
    const isAdminRole = isAdmin();
    const departmentsUser = getDepartmentsUser();
    const handleGetListCodeSource = async (obj, setFieldValue) => {
      try {
        const { data } = await getListCode(obj);
        setFieldValue("listCodeSource", data || []);
      } catch (error) {
        //console.error(error);
      }
    };
    const [checkedState, setCheckedState] = useState(false);
    return (
      <>
        {/* <FormikFocusError /> */}
        <Grid container spacing={1}>
          <Grid item xs={12} md={9}>
            <h3 class="sv-section-title">🔁 Thông tin dịch cũ</h3>
            <div className="new-product-section">
              <Grid
                container
                spacing={1}
                style={{ backgroundColor: "aliceblue" }}
              >
                <Grid item xs={12} sm={12} md={12}>
                  <OldService
                    handleAllocationRevenue={handleAllocationRevenue}
                  />
                </Grid>
              </Grid>
            </div>
            <h3 class="sv-section-title mt-2">
              <span class="symbol">⏳</span> Thông tin thẻ/liệu trình mới
              <CustomToggle
                values={values}
                setFieldValue={setFieldValue}
                onToggle={(state) => {
                  const formatStaffRevenues = values?.staffRevenues?.map(
                    (el) => ({
                      ...el,
                      actualAmount: 0,
                    })
                  );
                  setFieldValue("staffRevenues", formatStaffRevenues);
                  setFieldValue("paServiceRegister", []);
                  setFieldValue("drugs", []);
                  setFieldValue("totalAmount", 0);
                  setFieldValue("discount", 0);
                  setFieldValue("totalValue", 0);

                  if (state) {
                    setFieldValue("clientCard", null);
                  } else {
                    setFieldValue("clientCard", treatmentFree);
                  }
                }}
              />
            </h3>
            <div className="new-product-section">
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={2}>
                  <GlobitsPagingAutocomplete
                    api={
                      isAdminRole
                        ? pagingDepartment
                        : async () => ({
                            data: { content: departmentsUser || [] },
                          })
                    }
                    name={"department"}
                    label="Cơ sở"
                    onChange={(_, value) => {
                      setFieldValue("department", value);
                      const searchCodeSource = {
                        level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                        startDate: values?.startDate,
                        patientId: values?.patient?.id,
                        departmentId: value?.id,
                        voucherIds: Array.isArray(values?.voucherAllocations)
                          ? values.voucherAllocations
                              .map((item) => item?.voucher?.id)
                              .filter(Boolean)
                          : [],

                        invoiceItemIds: Array.isArray(
                          values?.invoiceItemAllocations
                        )
                          ? values.invoiceItemAllocations
                              .map((item) => item?.invoiceItem?.id)
                              .filter(Boolean)
                          : [],
                      };
                      handleGetListCodeSource(searchCodeSource, setFieldValue);
                    }}
                    required
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsDateTimePicker
                    name={"startDate"}
                    label="Ngày đăng ký"
                    maxDateMessage="Ngày đăng ký phải trước ngày hiện tại"
                    maxDate={new Date()}
                    isDateTimePicker
                    onChange={(value) => {
                      setFieldValue("startDate", value);
                      if (!value) return;

                      const searchCodeSource = {
                        level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                        startDate: value,
                        patientId: values?.patient?.id,
                        departmentId: values?.department?.id,
                        voucherIds: Array.isArray(values?.voucherAllocations)
                          ? values.voucherAllocations
                              .map((item) => item?.voucher?.id)
                              .filter(Boolean)
                          : [],

                        invoiceItemIds: Array.isArray(
                          values?.invoiceItemAllocations
                        )
                          ? values.invoiceItemAllocations
                              .map((item) => item?.invoiceItem?.id)
                              .filter(Boolean)
                          : [],
                      };

                      handleGetListCodeSource(searchCodeSource, setFieldValue);
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsDateTimePicker
                    name={"endDate"}
                    label="Ngày hết hạn sử dụng"
                    isDateTimePicker
                  />
                </Grid>
                {values?.defaultCard ? (
                  <Grid item xs={6} sm={6} md={4}>
                    <GlobitsPagingAutocomplete
                      api={pagingClientCard}
                      name={"clientCard"}
                      label="Thẻ"
                      filterOptions={filterBaseOptions}
                      searchObject={{ type: TYPE_CARD[0].value }}
                      onChange={(_, value) => {
                        handleOnChangeCard(value);
                      }}
                      ListboxComponent={forwardRef((props, ref) => {
                        const { children, ...other } = props;
                        return (
                          <ul {...other} ref={ref}>
                            <ol>
                              <li>{children}</li>
                            </ol>
                          </ul>
                        );
                      })}
                      renderOption={(option) => renderOptionsTrement(option)}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={6} sm={6} md={4}>
                    <GlobitsPagingAutocomplete
                      api={pagingClientCard}
                      name={"clientCard"}
                      label="Liệu trình"
                      filterOptions={filterBaseOptions}
                      searchObject={{ type: TYPE_CARD[1].value, isUsing: true }}
                      onChange={(_, value) => {
                        handleOnChangeService(value);
                      }}
                      ListboxComponent={forwardRef((props, ref) => {
                        const { children, ...other } = props;
                        return (
                          <ul {...other} ref={ref}>
                            <ol>
                              <li>{children}</li>
                            </ol>
                          </ul>
                        );
                      })}
                      renderOption={(option) => renderOptionsTrement(option)}
                    />
                  </Grid>
                )}

                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsAutocomplete
                    label={"Loại giá"}
                    options={values?.clientCard?.clientCardFees?.map(
                      (item) => ({
                        ...item?.patientTypeService,
                        price: item?.price,
                        vatIncluded: item?.vatIncluded,
                        serviceVAT: item?.serviceVAT,
                      })
                    )}
                    onChange={(_, value) => {
                      setFieldValue("patientTypeService", value);
                      let vatPercent = +value?.serviceVAT?.vatPercent || 0;

                      setFieldValue("price", value?.price);
                      setFieldValue("priceWithTax", value?.vatIncluded);

                      let taxTotal;
                      if (value?.vatIncluded) {
                        taxTotal =
                          ((value?.price * values?.quantity -
                            values?.discount -
                            values?.oldCredit) /
                            (vatPercent + 100)) *
                          vatPercent;
                      } else {
                        taxTotal =
                          (value?.price * values?.quantity -
                            values?.discount -
                            values?.oldCredit) *
                          ((vatPercent || 0) / 100);
                      }
                      setFieldValue("taxTotal", taxTotal);
                    }}
                    name={"patientTypeService"}
                    getOptionLabel={(option) => {
                      return option?.name
                        ? `${option.name}${
                            option?.price
                              ? `: ${formatMoney(option.price)}`
                              : ""
                          }`
                        : "";
                    }}
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsVNDCurrencyInputOnlyChange
                    isOnlyOnChange
                    label={"Giá"}
                    name={"price"}
                    onChange={handleOnChangePrice}
                    disabled={
                      PERMISSION_ROLE_HIS_PAYMENT && !isPaymentPermission
                    }
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsVNDCurrencyInput
                    label={"Thành tiền"}
                    name={"totalAmount"}
                    disabled
                    onChange={handleOnChangeTotalAmount}
                  />
                </Grid>
                {values?.defaultCard && (
                  <Grid item xs={6} sm={6} md={2}>
                    <GlobitsVNDCurrencyInput
                      label={"Giá trị sử dụng"}
                      disabled={!values?.allowUpdateUsedValue}
                      name={"totalValue"}
                    />
                  </Grid>
                )}
                {values?.defaultCard && (
                  <>
                    <Grid item xs={6} sm={6} md={4}>
                      <GlobitsPagingAutocomplete
                        api={pagingProgram}
                        searchObject={{
                          codes: listFreeCode,
                          productCode: values?.clientCard?.code,
                          isPaying: false,
                        }}
                        label={"Chương trình khuyến mãi"}
                        name={`promotionProgram`}
                        getOptionDisabled={(option) => {
                          // Lấy giá trị hiện tại: đơn giá * số lượng - tiền khấu trừ (nếu có)
                          const currentAmount =
                            (values?.price || 0) * (values?.quantity || 1) -
                            (values?.oldCredit ||
                              values?.oldTreatmentCredit ||
                              0);
                          // Disable option nếu giá trị đơn hàng tối thiểu > 0 và thành tiền < >giá trị đơn hàng tối thiểu
                          if (
                            option?.minInvoiceAmount > 0 &&
                            currentAmount < option?.minInvoiceAmount
                          ) {
                            return true;
                          }
                          return false;
                        }}
                        onChange={(_, value) => {
                          setFieldValue(`promotionProgram`, value);
                          if (!value) {
                            // Tính lại thành tiền khi bỏ chọn CTKM
                            const price = values?.price || 0;
                            const quantity = values?.quantity || 1;
                            const newTotalAmount = price * quantity;

                            setFieldValue("discount", 0);
                            setFieldValue("percentDiscount", 0);
                            setFieldValue("totalAmount", newTotalAmount);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} md={2}>
                      <GlobitsNumberInput
                        label={"% giảm giá"}
                        disabled={
                          REQUIRED_CTKM_DISCOUNT && !values?.promotionProgram
                        }
                        name={"percentDiscount"}
                        onChange={(e) => {
                          let percentDiscount = +e?.target.value;
                          setFieldValue("percentDiscount", percentDiscount);
                          setFieldValue(
                            "discount",
                            (values?.price *
                              values?.quantity *
                              percentDiscount) /
                              100
                          );
                        }}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsVNDCurrencyInputOnlyChange
                    isOnlyOnChange
                    label={"Số tiền giảm"}
                    name={"discount"}
                    disabled={
                      REQUIRED_CTKM_DISCOUNT && !values?.promotionProgram
                    }
                    onChange={(e) => {
                      let discount = +e?.target.value;
                      setFieldValue("discount", discount);
                      const totalAmount = values?.price;
                      let percentDiscount = (discount / totalAmount) * 100;
                      setFieldValue("percentDiscount", percentDiscount);
                    }}
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsVNDCurrencyInput
                    label={"Tiền Vat"}
                    name={`taxTotal`}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsTextField
                    label={"Mã giảm giá"}
                    name={"marketingVoucherCode"}
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={2} container alignItems="center">
                  <GlobitsCheckBox
                    label={"Lấy theo giá tổng"}
                    name={"isTotalPriceUsed"}
                    disabled
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={3} container alignItems="center">
                  <GlobitsCheckBox
                    label="Cấn trừ từ đơn hàng/tiền cọc"
                    checked={checkedState}
                    onChange={(e) => {
                      const value = e.target.checked;
                      setCheckedState(value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <GlobitsTextField
                    label={"Ghi chú"}
                    name={"note"}
                    isTextArea
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>

          <Grid item xs={12} md={3}>
            <RowTotalChangeTreatmentPlan data={values} />
          </Grid>

          {/* Danh sách trừ tiền cọc và đơn hàng */}
          {checkedState && (
            <Grid item xs={12} md={12}>
              <DeductionList initChangeService={initChangeService} />
            </Grid>
          )}

          <Grid item xs={12} md={12}>
            <span class="symbol sv-section-title">⏳ Phân bổ</span>
            <div className="new-product-section">
              <Grid container spacing={1}>
                <RegisterChangeTreatmentStaffsRevenue
                  handleAddStaff={handleAddStaff}
                  totalAmount={totalAmountRevenues}
                  popupChangeType={POPUP_TYPE_CHANGE_SERVICE}
                />
              </Grid>
            </div>
          </Grid>

          {!values?.defaultCard && (
            <Grid item xs={12} md={12}>
              <span class="symbol sv-section-title">📊 Thông tin dịch vụ</span>
              <div className="new-product-section">
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} md={2}>
                    <p className="table-section-title">
                      Danh sách dịch vụ/sản phẩm
                    </p>
                  </Grid>
                  {values?.clientCard?.isEditable && (
                    <>
                      <Grid item xs={12} sm={6} md={2}>
                        <GlobitsPagingAutocomplete
                          disableClearable
                          label={"Chọn dịch vụ"}
                          name={"servicePush"}
                          api={pagingHealthCareService}
                          searchObject={{
                            serviceGroupIds:
                              values?.clientCard?.serviceGroups?.map(
                                (item) => item?.serviceGroup?.id
                              ) || [],
                          }}
                          ListboxComponent={forwardRef((props, ref) => {
                            const { children, ...other } = props;
                            return (
                              <ul {...other} ref={ref}>
                                <ol>
                                  <li>{children}</li>
                                </ol>
                              </ul>
                            );
                          })}
                          renderOption={(option) =>
                            renderOptionsService(option)
                          }
                          onChange={(_, value) => {
                            setFieldValue("servicePush", value);
                          }}
                          filterOptions={filterBaseOptions}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2}>
                        <GlobitsPagingAutocomplete
                          disableClearable
                          label={"Sản phẩm"}
                          api={pagingDrug}
                          filterOptions={filterBaseOptions}
                          searchObject={{
                            abstractProductIds:
                              values?.clientCard?.abstractProducts?.map(
                                (item) => item?.abstractProduct?.id
                              ) || [],
                          }}
                          name={"drugPush"}
                          ListboxComponent={forwardRef((props, ref) => {
                            const { children, ...other } = props;
                            return (
                              <ul {...other} ref={ref}>
                                <ol>
                                  <li>{children}</li>
                                </ol>
                              </ul>
                            );
                          })}
                          renderOption={(option) => renderOptionsDrug(option)}
                          onChange={(_, value) => {
                            setFieldValue("drugPush", value);
                          }}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={6}
                        className="flex align-end justify-between"
                      >
                        <CommonButton onClick={handleAddProductAndService}>
                          <ArrowDownward />
                        </CommonButton>
                        <PromotionProgram
                          setFieldValue={setFieldValue}
                          initialValues={values}
                        />
                      </Grid>
                    </>
                  )}
                  {values?.selectedVoucher && (
                    <Grid item xs={12}>
                      <div
                        style={{
                          color: "#1976d2",
                          fontStyle: "italic",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span
                          style={{ fontWeight: 500 }}
                          className="flex align-center gap-1"
                        >
                          <ButtonDeleteProgram
                            setFieldValue={setFieldValue}
                            values={values}
                          />
                          Chương trình khuyến mãi đã chọn:
                        </span>
                        <span style={{ marginLeft: 4 }}>
                          {values?.selectedVoucher?.name}
                        </span>
                      </div>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <PaServiceRegisterTable
                      listVatPercent={listVatPercent}
                      oldCredit={values?.oldCredit}
                    />
                  </Grid>
                </Grid>
              </div>
            </Grid>
          )}

          {values?.clientCard && values?.defaultCard && (
            <Grid item xs={12} md={6}>
              <span class="symbol sv-section-title">🧑‍🤝‍🧑 Người dùng</span>

              <div className="new-product-section">
                <Grid container spacing={1}>
                  <CardUser values={values} setFieldValue={setFieldValue} />
                </Grid>
              </div>
            </Grid>
          )}
        </Grid>
      </>
    );
  }
);

const OldService = observer(({ handleAllocationRevenue }) => {
  const { values, setFieldValue } = useFormikContext();
  const totalPerformedTimes = getIn(
    values,
    "oldPatientServiceRegister.totalPerformedTimes"
  );
  const totalTreatmentTimes = getIn(
    values,
    "oldPatientServiceRegister.totalTreatmentTimes"
  );
  const service = getIn(values, "oldPatientServiceRegister.service");

  let percent = (+totalPerformedTimes * 100) / +totalTreatmentTimes || 0;

  const handleOnchangeOldService = (e) => {
    let oldCredit = +e?.target?.value;
    setFieldValue("oldCredit", oldCredit);
    let newStaffRevenues = [
      ...(values?.staffRevenues?.length > 0 ? values?.staffRevenues : []),
    ];
    const staffRevenues = handleAllocationRevenue(
      values?.totalAmount,
      newStaffRevenues,
      oldCredit
    );

    let formatDataService;
    let formatDataDrug;
    // const discount = +values?.discount || 0;

    // xử lí nếu khấu trừ > 0 thì phân bổ tiền khấu trừ lại
    if (oldCredit >= 0) {
      const percentOldCreditItem =
        oldCredit / values?.totalAmount - (values?.discount || 0); // tính % có thể phân bổ xuống

      formatDataService = values?.paServiceRegister?.map((el, ind) => {
        const oldCredit = percentOldCreditItem * (el?.amount || 0);
        const price = el?.price || 0;
        const quantity = el?.quantity || 1;
        // Clear CTKM khi thay đổi tiền khấu trừ
        return {
          ...el,
          oldCredit: oldCredit,
          promotionProgram: null,
          discount: 0,
          percentDiscount: 0,
          amount: price * quantity,
        };
      });

      formatDataDrug = values?.drugs?.map((el, ind) => {
        const oldCredit = percentOldCreditItem * (el?.amount || 0);
        const price = el?.price || 0;
        const soldQuantity = el?.soldQuantity || 1;
        // Clear CTKM khi thay đổi tiền khấu trừ
        return {
          ...el,
          oldCredit: oldCredit,
          promotionProgram: null,
          discount: 0,
          percentDiscount: 0,
          amount: price * soldQuantity,
        };
      });

      //  kiểm tra tổng
      let allocatedTotalSv =
        formatDataService?.length > 0
          ? formatDataService.reduce((sum, el) => sum + +el.oldCredit, 0)
          : 0;
      let allocatedTotalDrug =
        formatDataDrug?.length > 0
          ? formatDataDrug.reduce((sum, el) => sum + +el.oldCredit, 0)
          : 0;
      let allocatedTotal = allocatedTotalSv + allocatedTotalDrug;

      let diff = +(values?.oldCredit - allocatedTotal);

      //  cộng/trừ chênh lệch vào item cuối cùng
      if (diff !== 0) {
        if (formatDataDrug?.length > 0) {
          formatDataDrug[formatDataDrug.length - 1].oldCredit =
            +formatDataDrug[formatDataDrug.length - 1].oldCredit + diff;
        } else if (formatDataService?.length > 0) {
          formatDataService[formatDataService.length - 1].oldCredit =
            +formatDataService[formatDataService.length - 1]?.oldCredit + diff;
        }
      }
    }
    setFieldValue("paServiceRegister", formatDataService);
    setFieldValue("drugs", formatDataDrug);
    setFieldValue("staffRevenues", staffRevenues);
  };
  return (
    <Grid container spacing={1} className="flex align-center justify-between">
      <Grid item xs={12} md={4}>
        <div className="pl-1 pr-1">
          <div>
            <span className="service-code">{service?.code}</span>{" "}
            <span className="service-name">{service?.tradeName}</span>
          </div>
          <div class="fancy-progress-wrapper mt-1">
            <div class="fancy-progress-text">
              {totalPerformedTimes} | {totalTreatmentTimes}
            </div>
            <div class="fancy-progress-bar">
              <div
                class="fancy-progress-fill"
                style={{ width: `${percent}%` }}
              ></div>
            </div>
          </div>
          <div className="flex mt-2">
            <div>
              Cần thu:{" "}
              <b style={{ color: "red" }}>
                {formatMoney(
                  values?.oldPatientServiceRegister?.amountActuallyPaid
                )}
              </b>
            </div>
            <span className="mx-2 text-gray-400">|</span>
            <div>
              Đã thu:{" "}
              <b style={{ color: "green" }}>
                {formatMoney(
                  values?.oldPatientServiceRegister?.totalBillPatientPaid || 0
                )}
              </b>
            </div>
          </div>
        </div>
      </Grid>
      <Grid item xs={12} md={2} className="">
        <GlobitsNumberInput
          name="oldPatientServiceRegister.remainingTreatmentTimes"
          label="Tổng số buổi sau đổi"
        />
      </Grid>
      <Grid item xs={12} md={2} className="">
        <GlobitsVNDCurrencyInput
          name="oldPatientServiceRegister.totalUsed"
          label="Tổng tiền đã dùng"
          disabled={totalPerformedTimes == 0}
          onChange={(e) => {
            let totalUsed = +e?.target?.value || 0;
            setFieldValue("oldPatientServiceRegister.totalUsed", totalUsed);
            setFieldValue(
              "oldPatientServiceRegister.remainingAmount",
              (values?.oldPatientServiceRegister?.totalBillPatientPaid || 0) -
                totalUsed
            );
          }}
        />
      </Grid>
      <Grid item xs={12} md={2} className="">
        <GlobitsVNDCurrencyInput
          name="oldPatientServiceRegister.remainingAmount"
          label="Tổng tiền còn lại"
          disabled
        />
      </Grid>
      <Grid item xs={12} md={2} className="flex">
        <GlobitsVNDCurrencyInputOnlyChange
          isOnlyOnChange
          name="oldCredit"
          label="Tiền khấu trừ dịch vụ cũ"
          onChange={handleOnchangeOldService}
        />
        <Tooltip title="Tiền khấu trừ dịch vụ cũ = tổng tiền khấu trừ của các dịch vụ,sản phẩm">
          <Info fontSize="small" className="ml-1" color="primary" />
        </Tooltip>
      </Grid>
    </Grid>
  );
});

const renderOptionsTrement = (option) => {
  return (
    <div
      style={{
        gap: "16px",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          minWidth: "100px",
          fontWeight: "bold",
          fontSize: "14px",
          color: "#000",
          wordBreak: "break-word",
        }}
      >
        {option?.name}
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
        }}
      >
        {option?.clientCardFees?.map((el, ind) => (
          <div
            key={ind}
            style={{
              fontSize: "10px",
              borderRadius: "6px",
              whiteSpace: "nowrap",
              backgroundColor: ind % 2 === 1 ? "#f1632159" : "#a8e1a8",
              padding: "2px",
              color: "#000",
            }}
          >
            {el?.patientTypeService?.name}:{" "}
            <strong>{el?.price?.toLocaleString("vi-VN") || 0}</strong>
          </div>
        ))}
      </div>
    </div>
  );
};

const DialogError = observer(({ patient, setFieldValue, values }) => {
  const { openConfirmMessage, handleCloseConfirmMessage } =
    useStore().patientManagementStore.allServicesTabStore;
  return (
    <>
      {!!openConfirmMessage && (
        <ConfirmPopup
          open={!!openConfirmMessage}
          onClose={() => {
            handleCloseConfirmMessage(null);
            if (!values?.id) {
              // khi đóng popup thì reset lại ngày đăng kí
              setFieldValue("startDate", new Date());
            }
          }}
          text={openConfirmMessage}
          onConfirm={() => {
            const url =
              Config.ROOT_PATH +
              PathModule.PATIENT_MANAGEMENT +
              `/patient-general?patientId=${patient?.id}`;

            window.open(url, "_blank");
          }}
          textConfirm={"Thông tin khách"}
          textClose={"Quay lại"}
          title="Đăng ký thất bại"
          isNotAPromise
        />
      )}
    </>
  );
});

const CustomToggle = ({ onToggle, setFieldValue, values }) => {
  const handleClick = () => {
    if (onToggle) {
      onToggle(!values?.defaultCard);
    }
    setFieldValue("defaultCard", !values?.defaultCard);
  };

  return (
    <div className="flex gap-2 align-center toggle-wraper mb-0">
      <div className="toggle-container">
        <div
          className={`custom-toggle ${values?.defaultCard ? "active" : ""}`}
          onClick={() => handleClick()}
        >
          <div className="toggle-circle" />
        </div>
        <div>
          {values?.defaultCard ? "Đổi sang liệu trình" : "Đổi sang thẻ"}
        </div>
      </div>
    </div>
  );
};
export default memo(ChangeServiceToClientCardPopup);
